/* eslint-disable no-nested-ternary */
import { useScreenSize } from '@hooks';
import { Button, Flex, Image, theme, Typography } from '@styles';
import { bool, func, oneOf, shape } from 'prop-types';
import React from 'react';

import { Icon } from '../Icon';
import { buttonLayoutByVariant } from './SquareActionButton.layoutProps';

const SquareActionButton = ({
  isSemivisible,
  isVisible,
  onClick,
  rank,
  variant,
}) => {
  const { isTabletSM } = useScreenSize();

  if (isVisible) {
    return (
      <Button
        alignItems="center"
        bg={theme.colors.white[5]}
        border={`${isTabletSM ? 1 : 2}px solid ${theme.colors.white[10]}`}
        borderRadius={isTabletSM ? 5 : 8}
        flexShrink={0}
        height={isTabletSM ? 46 : 65}
        justifyContent="center"
        onClick={onClick}
        position="relative"
        variant="quaternary"
        width={isTabletSM ? 46 : 65}
      >
        {variant === 'rank' ? (
          <Flex>
            {rank?.points > 0 && (
              <Flex
                background="linear-gradient(180deg, rgba(132, 114, 0, 0.00) 0.14%, rgba(132, 114, 0, 0.60) 250.87%); "
                left="50%"
                minHeight="100%"
                minWidth="100%"
                position="absolute"
                top="50%"
                transform="translate(-50%, -50%)"
              >
                <Typography
                  alignSelf="center"
                  color={theme.colors.schoolBusYellow[100]}
                  variant="MS-bold-s16-lh25"
                  width="100%"
                >{`+${rank.points}`}</Typography>
              </Flex>
            )}
            <Image
              alt="Rank"
              height="auto"
              src={rank?.image_large}
              width={isTabletSM ? 32 : 44}
            />
          </Flex>
        ) : (
          <Icon
            height={isTabletSM ? 24 : 32}
            SVG={buttonLayoutByVariant[variant].svg}
            width={isTabletSM ? 24 : 32}
          />
        )}
      </Button>
    );
  }

  if (isSemivisible) {
    return (
      <Flex
        bg={theme.colors.white[5]}
        border={`${isTabletSM ? 1 : 2}px solid ${theme.colors.white[10]}`}
        borderRadius={isTabletSM ? 5 : 8}
        flexShrink={0}
        height={isTabletSM ? 46 : 65}
        opacity={0.2}
        width={isTabletSM ? 46 : 65}
      />
    );
  }

  return null;
};

SquareActionButton.propTypes = {
  isSemivisible: bool,
  isVisible: bool,
  onClick: func,
  rank: shape,
  variant: oneOf([
    'text',
    'report',
    'rank',
    'sidePanelOpen',
    'sidePanedClosed',
  ]),
};

SquareActionButton.defaultProps = {
  isSemivisible: false,
  isVisible: false,
  onClick: null,
  rank: null,
  variant: '',
};

export default SquareActionButton;
